import store from "../store";
import { ADMIN_INITIAL, ADMIN_UPDATE, ERROR_INITIAL, ERROR_UPDATE } from "../store/slices";
import { DatabaseInstance } from "./databaseClass";
import { ImageInstance } from "./imageClass";

interface IImage {
  id: string;
  imageUrl: string;
  createdAt: string;
  linkUrl?: string | null;
}

class AdminClass {
  constructor() {}

  public checkIfAdmin = async () => {
    const isAdmin = store.getState().user.isAdmin;

    if (!isAdmin) {
      return false;
    } else {
      return true;
    }
  };

  public manageUserSeeds = async ({
    user,
    seeds,
    method,
    description,
    isChallenge,
  }: {
    user: any;
    seeds: number;
    method: string;
    description: string;
    isChallenge: boolean;
  }) => {
    if (seeds === 0 || description === "") {
      return;
    }

    // if method is add then endpoint is admin/add-seeds else it is admin/remove-seeds
    const endpoint = method === "add" ? `admin/add-seeds-to-user` : "admin/deduct-seeds-from-user";

    const data = {
      data: {
        userId: user.id,
        seeds,
        description,
        isChallenge,
      },
      endpoint,
    };

    console.log("data", data);

    const res = await DatabaseInstance.updateRecord(data);

    return res;
  };

  public getUserSeedLedger = async (userId: string) => {
    const data = {
      endpoint: `admin/get-user-seed-ledger/${userId}`,
    };

    const res = await DatabaseInstance.getRecord(data);

    return res;
  };

  public getUserBusinesses = async (userId: string) => {
    const data = {
      endpoint: `admin/get-user-businesses/${userId}`,
    };

    const res = await DatabaseInstance.getRecord(data);

    return res;
  };

  public removeUserFromBusiness = async ({ user, businessId }: { user: any; businessId: string }) => {
    const data = {
      endpoint: `admin/remove-user-from-business/${user.id}/ ${businessId}`,
    };

    await DatabaseInstance.deleteRecord(data);

    return;
  };

  public addUserToBusiness = async ({
    user,
    businessId,
    businessType,
  }: {
    user: any;
    businessId: string;
    businessType: "brand" | "venue";
  }) => {
    const data = {
      endpoint: `admin/add-user-to-business`,
      data: {
        userId: user.id,
        businessId,
        businessType,
        role: "affiliate",
      },
    };

    await DatabaseInstance.createRecord(data);
  };

  public addProductToDB = async ({
    productName,
    brandId,
    categoryId,
    subcategoryId,
    thcContent,
    cbdContent,
    cbnContent,
  }: {
    productName: string;
    brandId: number;
    categoryId: number;
    subcategoryId: number;
    thcContent: number;
    cbdContent: number;
    cbnContent: number;
  }) => {
    const data = {
      endpoint: `products/add-product`,
      data: {
        name: productName.replace(/\s+$/, ""),
        brandId,
        categoryId,
        subcategoryId,
        thcContent,
        cbdContent,
        cbnContent,
      },
    };
    await DatabaseInstance.createRecord(data);
  };

  public updateBrand = async (brandId: number, newData: any, brandName: string) => {
    try {
      //process images if we have images set.
      let displayImgRes = null;
      let avatarImgRes = null;

      //getting the imageURLS and saving to S3 buckets
      if (newData.displayImg) {
        displayImgRes = await ImageInstance.uploadImageToS3(newData.displayImg, "brands", brandName);
        console.log("display image in adminClass", displayImgRes);
      }
      if (newData.avatarImg) {
        avatarImgRes = await ImageInstance.uploadImageToS3(newData.avatarImg, "brands", brandName);
        console.log("avatar image in adminClass", avatarImgRes);
      }

      // Check if uploads (if attempted) were successful
      if ((newData.displayImg && !displayImgRes) || (newData.avatarImg && !avatarImgRes)) {
        store.dispatch(
          ERROR_UPDATE({
            data: {
              ...ERROR_INITIAL,
              error: true,
              message: "Failed to upload image to S3. Brand updates not saved",
            },
          }),
        );
        return;
      }

      //construct brand data, including image URLs if they were provided
      const brandUpdates = {
        ...newData,
        ...(displayImgRes && { displayUrl: displayImgRes.fileKey }),
        ...(avatarImgRes && { avatarUrl: avatarImgRes.fileKey }),
      };
      const endpoint = `admin/update-brand/${brandId}`;

      const record = await DatabaseInstance.updateRecord({
        data: brandUpdates,
        endpoint,
      });

      //if we don't return a record, there's something wrong
      if (!record) {
        store.dispatch(
          ERROR_UPDATE({
            data: {
              ...ERROR_INITIAL,
              error: true,
              message: "Failed to update brand in database.",
            },
          }),
        );
        return false;
      }
      return record;
    } catch (error) {
      console.log("there was an error updating brand");
    }
  };

  public addBrandToDB = async ({
    brandName,
    email,
    website,
    city,
    stateId,
    licenseNumber,
    displayImg,
    avatarImg,
  }: {
    brandName: string;
    email: string;
    website: string;
    city: string;
    stateId: number;
    licenseNumber: string;
    displayImg: any;
    avatarImg: any;
  }) => {
    //process images if we have images set.
    let displayImgRes = null;
    let avatarImgRes = null;

    //getting the imageURLS and saving to S3 buckets
    if (displayImg) {
      displayImgRes = await ImageInstance.uploadImageToS3(displayImg, "brands", brandName);
    }
    if (avatarImg) {
      avatarImgRes = await ImageInstance.uploadImageToS3(avatarImg, "brands", brandName);
    }
    // Check if uploads (if attempted) were successful
    if ((displayImg && !displayImgRes) || (avatarImg && !avatarImgRes)) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: true,
            message: "Failed to upload image to S3.",
          },
        }),
      );
      return;
    }

    //construct brand data, including image URLs if they were provided
    const brandData = {
      name: brandName,
      email,
      website,
      city,
      stateId,
      licenseNumber,
      ...(displayImgRes && { displayUrl: displayImgRes.fileKey }),
      ...(avatarImgRes && { avatarUrl: avatarImgRes.fileKey }),
    };
    //format it for our Database instance to save to our DB
    const data = {
      endpoint: `brands/create-brand`,
      data: brandData,
    };

    const record = await DatabaseInstance.createRecord(data);
    //if we don't return a record, there's something wrong
    if (!record) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: true,
            message: "Failed to add brand to database.",
          },
        }),
      );
      return false;
    }

    return true;
  };

  public updateVenue = async (venueId: number, newData: any, venueName: string) => {
    try {
      //process images if we have images set.
      let displayImgRes = null;
      let avatarImgRes = null;

      //getting the imageURLS and saving to S3 buckets
      if (newData.displayImg) {
        displayImgRes = await ImageInstance.uploadImageToS3(newData.displayImg, "venues", venueName);
        console.log("display image in adminClass", displayImgRes);
      }
      if (newData.avatarImg) {
        avatarImgRes = await ImageInstance.uploadImageToS3(newData.avatarImg, "venues", venueName);
        console.log("avatar image in adminClass", avatarImgRes);
      }

      // Check if uploads (if attempted) were successful
      if ((newData.displayImg && !displayImgRes) || (newData.avatarImg && !avatarImgRes)) {
        store.dispatch(
          ERROR_UPDATE({
            data: {
              ...ERROR_INITIAL,
              error: true,
              message: "Failed to upload image to S3. Brand updates not saved",
            },
          }),
        );
        return;
      }

      //construct venue data, including image URLs if they were provided
      const venueUpdates = {
        ...newData,
        ...(displayImgRes && { displayUrl: displayImgRes.fileKey }),
        ...(avatarImgRes && { avatarUrl: avatarImgRes.fileKey }),
      };
      const endpoint = `admin/update-venue/${venueId}`;

      const record = await DatabaseInstance.updateRecord({
        data: venueUpdates,
        endpoint,
      });

      //if we don't return a record, there's something wrong
      if (!record) {
        store.dispatch(
          ERROR_UPDATE({
            data: {
              ...ERROR_INITIAL,
              error: true,
              message: "Failed to update venue in database.",
            },
          }),
        );
        return false;
      }
      return record;
    } catch (error) {
      console.log("there was an error updating venue");
    }
  };
  //add venue to db
  //need to get full address and state object to pass for backend to do it's location validation stuff
  public addVenueToDB = async ({
    name,
    type,
    dispensaryType,
    stateId,
    website,
    city,
    street,
    zip,
    licenseNumber,
    phoneNumber,
    displayImg,
    avatarImg,
  }: {
    name: string;
    type: string;
    dispensaryType: string;
    stateId: number; // takes in the whole state object
    website: string;
    city: string;
    street: string;
    zip: string;
    licenseNumber: string;
    phoneNumber: string;
    displayImg: any;
    avatarImg: any;
  }) => {
    //process images if we have images set.
    let displayImgRes = null;
    let avatarImgRes = null;

    //getting the imageURLS and saving to S3 buckets
    if (displayImg) {
      displayImgRes = await ImageInstance.uploadImageToS3(displayImg, "venues", name);
    }
    if (avatarImg) {
      avatarImgRes = await ImageInstance.uploadImageToS3(avatarImg, "venues", name);
    }
    // Check if uploads (if attempted) were successful
    if ((displayImg && !displayImgRes) || (avatarImg && !avatarImgRes)) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: true,
            message: "Failed to upload image to S3.",
          },
        }),
      );
      return;
    }

    const venueData = {
      name,
      type,
      dispensaryType,
      stateId,
      website,
      city,
      street,
      zip,
      phoneNumber,
      licenseNumber,
      ...(displayImgRes && { displayUrl: displayImgRes.fileKey }),
      ...(avatarImgRes && { avatarUrl: avatarImgRes.fileKey }),
    };

    console.log("venue data", venueData);

    const data = {
      endpoint: "venues/create-venue",
      data: venueData,
    };

    console.log("data for create record", data);

    const record = await DatabaseInstance.createRecord(data);
    //if we don't return a record, there's something wrong
    if (!record) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: true,
            message: "Failed to add venue to database.",
          },
        }),
      );
      return false;
    }
    return true;
  };

  public adminCreateUser = async (user: any) => {
    const data = {
      endpoint: "admin/create-user",
      data: user,
    };

    const res = await DatabaseInstance.createRecord(data);

    // if error, return error
    if (res.error) {
    }

    return res;
  };

  //TODO, GET ACTUAL ENDPOINT
  public adminCreateCustomer = async (customer: any) => {
    console.log("data recieved in adminclass", customer);
    const data = {
      endpoint: "admin/create-customer",
      data: customer,
    };

    const res = await DatabaseInstance.createRecord(data);

    // if error, return error
    if (res.error) {
    }

    return res;
  };

  //use this as example for new dnd, image upload to library
  public addAppDisplayImage = async (imageUrl: string, appLocation: string) => {
    const data = {
      endpoint: "images/manage-app-display-images",
      data: {
        imageUrl,
        appLocation,
      },
    };

    const res = await DatabaseInstance.createRecord(data);

    return res;
  };

  //"delete" an image
  public deleteAppDisplayImage = async (imageId: string, appLocation: string) => {
    const data = {
      endpoint: `images/manage-app-display-delete/${imageId}/${appLocation}`,
    };

    const res = await DatabaseInstance.deleteRecord(data);

    return res;
  };

  //instead of updating an image to display at app location, update the ordered array
  public updateAppDisplayActive = async (imageUrlArr: IImage[], appLocation: string) => {
    const data = {
      endpoint: "images/manage-app-display-active",
      data: {
        images: imageUrlArr,
        appLocation,
      },
    };

    const res = await DatabaseInstance.updateRecord(data);

    return res;
  };

  //retrieve array of display images availabe for app location
  //active true is carousel, active false is library
  public getAppDisplay = async (appLocation: string, active: boolean) => {
    const data = {
      endpoint: `images/manage-app-display/${appLocation}/${active}`,
    };

    const res = await DatabaseInstance.getRecord(data);
    return res;
  };

  // get all mvp feedback
  public getAllMvpFeedback = async () => {
    store.dispatch(
      ADMIN_UPDATE({
        data: {
          ...ADMIN_INITIAL,
          isLoading: true,
        },
      }),
    );
    const data = {
      endpoint: "admin/get-feedback",
    };

    const res = await DatabaseInstance.getRecord(data);

    console.log("feedback", res);

    store.dispatch(
      ADMIN_UPDATE({
        data: {
          ...ADMIN_INITIAL,
          feedback: res,
          isLoading: false,
        },
      }),
    );
    return res;
  };

  // handle marking feedback as completed
  public handleFeedbackCompletionToggle = async (feedbackId: string, completed: boolean) => {
    const data = {
      endpoint: `admin/update-feedback/${feedbackId}`,
      data: {
        completed: completed,
      },
    };

    console.log("data", data);

    const res = await DatabaseInstance.updateRecord(data);

    // if good res, replace the old feedback with the new one
    if (res.feedback) {
      store.dispatch(
        ADMIN_UPDATE({
          data: {
            ...ADMIN_INITIAL,
            feedback: store.getState().admin.feedback.map((item: any) => {
              return item.id === res.feedback.id ? res.feedback : item;
            }),
          },
        }),
      );
    }

    return res.feedback;
  };

  public getAppLocationAnalytics = async (zipCodes: string[]) => {
    const params = {
      endpoint: `admin/location-global-analytics?zipCodes=${zipCodes.join(",")}`,
    };

    const res = await DatabaseInstance.getRecord(params);

    console.log("res", res);
    return res;
  };

  public getUserSignUpAnalytics = async () => {
    const params = {
      endpoint: `admin/user-sign-up-analytics`,
    };

    const res = await DatabaseInstance.getRecord(params);

    console.log("res from sign up analytics", res);
    return res;
  };

  public toggleBanUser = async (userId: string) => {
    const data = {
      endpoint: `admin/toggle-ban-user/${userId}`,
    };

    const res = await DatabaseInstance.updateRecord(data);

    return res;
  };

  public sendGlobalNotification = async (notification: { title: string; body: string }) => {
    const data = {
      endpoint: "admin/send-global-notification",
      data: {
        ...notification,
      },
    };

    const res = await DatabaseInstance.createRecord(data);

    return res;
  };

  public getNewestUsers = async () => {
    const data = {
      endpoint: "admin/view-newest-users",
    };

    const res = await DatabaseInstance.getRecord(data);

    console.log("NEWEST USERS", res);

    return res;
  };

  public aggregatedUserAppAnalytics = async () => {
    const data = {
      endpoint: "admin/aggregated-user-analytics",
    };

    const res = await DatabaseInstance.getRecord(data);

    return res;
  };

  public getCheckOutQuestions = async (type: "dispensary" | "smokeshop") => {
    const data = {
      endpoint: `admin/get-checkout-questions?venueType=${type}`,
    };

    const res = await DatabaseInstance.getRecord(data);

    return res;
  };

  public addCheckOutQuestion = async (question: any) => {
    console.log("adding question", question);
    const data = {
      endpoint: `admin/add-checkout-question`,
      data: question,
    };

    const res = await DatabaseInstance.createRecord(data);

    return res;
  };

  public updateCheckOutQuestion = async (question: any) => {
    console.log("updating question", question);
    const data = {
      endpoint: `admin/update-checkout-question/${question.id}`,
      data: {
        ...question,
      },
    };

    const res = await DatabaseInstance.updateRecord(data);

    return res;
  };

  public deleteCheckOutQuestion = async (questionId: string) => {
    const data = {
      endpoint: `admin/delete-checkout-question/${questionId}`,
    };

    const res = await DatabaseInstance.deleteRecord(data);

    return res;
  };

  public deleteItem = async (itemId: string, itemType: string) => {
    const data = {
      endpoint: `admin/delete-item/${itemId}?itemType=${itemType}`,
    };

    const res = await DatabaseInstance.deleteRecord(data);

    return res;
  };

  public updateCustomer = async (newData: any) => {
    const customerId = newData.id;
    try {
      //construct venue data, including image URLs if they were provided
      const customerUpdates = {
        ...newData,
      };
      const endpoint = `admin/update-customer/${customerId}`;

      const record = await DatabaseInstance.updateRecord({
        data: customerUpdates,
        endpoint,
      });

      //if we don't return a record, there's something wrong
      if (!record) {
        store.dispatch(
          ERROR_UPDATE({
            data: {
              ...ERROR_INITIAL,
              error: true,
              message: "Failed to update customer in database.",
            },
          }),
        );
        return false;
      }
      return record;
    } catch (error) {
      console.log("there was an error updating customer");
    }
  };

  public generateCodes = async () => {
    const data = {
      endpoint: "admin/generate-user-referral-codes",
      data: {},
    };

    const res = await DatabaseInstance.createRecord(data);

    console.log("res", res);

    return res;
  };

  public fetchAllUserEmails = async () => {
    const data = {
      endpoint: "admin/fetch-all-user-emails",
    };

    const res = await DatabaseInstance.getRecord(data);

    return res.emails;
  };

  public fetchReport = async (query: string, replacements: string[]) => {
    const data = {
      endpoint: "admin/admin-reports",
      data: {
        query,
        replacements,
      },
    };

    const res = await DatabaseInstance.createRecord(data);

    return res;
  };
}

const AdminInstance = new AdminClass();

export { AdminInstance };
